@switch (customInputType()) {
  @case (customInput.ServiceArea) {
    <aw-drop-down
      [id]="inputId()"
      [formControl]="control()"
      [isLoading]="serviceAreaStore.isLoading()"
      [options]="serviceAreaStore.serviceAreas()"
      [searchable]="serviceAreaStore.serviceAreas().length > 7"
      [showClearOption]="true"
      name="name"
      valueAttribute="id" />
  }
  @case (customInput.TariffAreas) {
    @if (tariffAreaStore.tariffAreas().length <= 3) {
      <div class="flex flex-wrap gap-2">
        @for (
          tariffArea of tariffAreaStore.tariffAreas();
          track tariffArea.id
        ) {
          <button type="button" (click)="toggleTariffArea(tariffArea)">
            <aw-toggle-chip
              [text]="tariffArea.name"
              [isChecked]="isTariffAreaSelected(tariffArea)" />
          </button>
        }
      </div>
    } @else {
      <aw-multi-select-drop-down
        [id]="inputId()"
        [formControl]="control()"
        [isLoading]="tariffAreaStore.isLoading()"
        [options]="tariffAreaStore.tariffAreas()"
        [searchable]="tariffAreaStore.tariffAreas().length > 7"
        name="name"
        valueAttribute="id" />
    }
  }
  @case (customInput.ProofOfPurchase) {
    <aw-drop-down
      [id]="inputId()"
      [formControl]="control()"
      [isLoading]="layoutsStore.isLoading()"
      [options]="layoutsStore.layouts()"
      [searchable]="layoutsStore.layouts().length > 7"
      [showClearOption]="true"
      name="layoutName"
      valueAttribute="id" />
  }
  @case (customInput.Salutations) {
    <aw-list-input [id]="inputId()" [formControl]="control()" />
  }
  @case (customInput.OperatorMappings) {
    <aw-on-demand-journey-form class="block w-full" />
  }
}
